import { render } from "./PlanningPage.vue?vue&type=template&id=57bea59c&scoped=true"
import script from "./PlanningPage.vue?vue&type=script&lang=js"
export * from "./PlanningPage.vue?vue&type=script&lang=js"

import "./PlanningPage.vue?vue&type=style&index=0&id=57bea59c&lang=scss&scoped=true"

import exportComponent from "/home/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bea59c"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QBtn});
